/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const MenuIcon: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_1_661" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <rect width="24" height="24" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_1_661)">
      <path d="M4 17.625C3.78333 17.625 3.60433 17.5543 3.463 17.413C3.321 17.271 3.25 17.0917 3.25 16.875C3.25 16.675 3.321 16.5 3.463 16.35C3.60433 16.2 3.78333 16.125 4 16.125H20C20.2167 16.125 20.396 16.2 20.538 16.35C20.6793 16.5 20.75 16.675 20.75 16.875C20.75 17.0917 20.6793 17.271 20.538 17.413C20.396 17.5543 20.2167 17.625 20 17.625H4ZM4 12.75C3.78333 12.75 3.60433 12.679 3.463 12.537C3.321 12.3957 3.25 12.2167 3.25 12C3.25 11.7833 3.321 11.604 3.463 11.462C3.60433 11.3207 3.78333 11.25 4 11.25H20C20.2167 11.25 20.396 11.3207 20.538 11.462C20.6793 11.604 20.75 11.7833 20.75 12C20.75 12.2167 20.6793 12.3957 20.538 12.537C20.396 12.679 20.2167 12.75 20 12.75H4ZM4 7.875C3.78333 7.875 3.60433 7.8 3.463 7.65C3.321 7.5 3.25 7.325 3.25 7.125C3.25 6.90833 3.321 6.72933 3.463 6.588C3.60433 6.446 3.78333 6.375 4 6.375H20C20.2167 6.375 20.396 6.446 20.538 6.588C20.6793 6.72933 20.75 6.90833 20.75 7.125C20.75 7.325 20.6793 7.5 20.538 7.65C20.396 7.8 20.2167 7.875 20 7.875H4Z" fill="#262626"/>
    </g>
  </svg>

);

export default MenuIcon;
